import React, { useState } from "react";
import { Link } from "react-router-dom";
import { wxCodeImg } from "../../static/option";
import LoginChoose from "./LoginChoose";

import { Dropdown, Menu } from "antd";

import "./style.scss";
const navItem = [
  { title: "首页", path: "/" },
  { title: "司法拍卖", path: "/search?currentIndex=1" },
  { title: "流拍寻宝", path: "/search?currentIndex=2" },
  { title: "资产拍卖", path: "/search?currentIndex=3" },
  { title: "资产推介", path: "/search?currentIndex=4" },
  { title: "入驻" },
];
const navSettledItem = [
  { title: "经纪品牌(门店)入驻", path: "/serviceProvider" },
  { title: "独立经纪人入驻", path: "/brokerIndex" },
  { title: "债权人入驻", path: "/institution" },
  { title: "供应商入驻", path: "/supplierApply" },
];

export default (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showNavSettledItem, setShowNavSettledItem] = useState(false);

  const menu = (navSettledItem, index) => {
    return (
      <Menu>
        {navSettledItem.map((item) => {
          return (
            <Menu.Item
              key={item.path}
              onClick={() => {
                console.log(props);
                setCurrentIndex(5);
                setShowNavSettledItem(false);
              }}
            >
              <Link to={item.path}>{item.title}</Link>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  return (
    <div className={"common_header"}>
      <div className={"top"}>
        <div className={"top_content container-1200"}>
          <div className={"band"}>
            <Link to={"/"}>
              <img
                src="https://api.faeping.com/storage/uploads/20250403/1743664990659_%E7%9F%A9%E7%9F%B3%E9%98%B5logo2x.png"
                alt=""
              />
              矩阵资产
            </Link>
          </div>
          <div className={"right"}>
            <ul className={"navbar"}>
              {navItem.map((item, index) => {
                if (index !== navItem.length - 1) {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        setCurrentIndex(index);
                      }}
                      className={
                        index === parseInt(props.currentIndex) ? "active" : ""
                      }
                    >
                      <Link to={item.path}>{item.title}</Link>
                    </li>
                  );
                } else {
                  return (
                    <Dropdown
                      overlay={menu(navSettledItem, index)}
                      visible={showNavSettledItem}
                      onVisibleChange={(visible) => {
                        setShowNavSettledItem(visible);
                      }}
                      key={index}
                      placement="bottomCenter"
                    >
                      <li
                        className={
                          parseInt(props.currentIndex) === 5 ? "active" : ""
                        }
                      >
                        <a>{item.title}</a>
                      </li>
                    </Dropdown>
                  );
                }
              })}
            
              <li>
                小程序
                <div className={"code-img"}>
                  <div className={"code-img-box"}>
                    <div className={"wx"}>
                      <img src={wxCodeImg} alt="" />
                      <p>微信小程序</p>
                    </div>

                  </div>
                </div>
              </li>
            </ul>
            <LoginChoose />
          </div>
        </div>
      </div>
    </div>
  );
};
